import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Links = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard mb-5">
      <div className="col col-12">
        {edit && <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} />}
        <Info userCopy={userCopy} setUserCopy={setUserCopy} setUser={setUser} setEdit={setEdit} edit={edit} />
      </div>
    </div>
  );
};

export default Links;

const Info = ({ userCopy, setUserCopy, setUser, setEdit, edit }) => {
  const handleRemoveLinks = (_id) => {
    const newUserCopy = { ...userCopy };
    let tempArr = newUserCopy.links;
    tempArr = tempArr.filter((el) => el._id !== _id);
    newUserCopy.links = tempArr;

    editUser(newUserCopy, setUser);
  };

  return (
    <>
      {!edit ? (
        <h2 className="heading">
          <small>Links</small>
          <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
            <i className="bi bi-plus-circle"></i> Add new
          </button>
        </h2>
      ) : (
        <hr style={{ width: 'calc(100% + 24px)', margin: '0 -12px 15px -12px' }} />
      )}
      <div className="content mx-5">
        <div className="main hr">
          {userCopy?.links?.length === 0 && (
            <div className="col col-12">
              <span className="lead">No details has been provided yet.</span>
            </div>
          )}
          {userCopy.links &&
            userCopy.links.map((el) => (
              <div className="row" key={el._id}>
                <div className="col col-12 col-md-10 col-xl-11">
                  <p className="mb-0">
                    <small style={{ whiteSpace: 'pre-line' }}>{el.type}</small>
                  </p>
                  <a href={`http://${el.url}`} target="_blank" rel="noreferrer" style={{ opacity: '0.5', textDecoration: 'none' }}>
                    {el.url}
                  </a>
                </div>
                <div className="col col-md-2 col-xl-1 text-end">
                  <button type="button" className="btn btn-link del" onClick={() => handleRemoveLinks(el._id)}>
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const [form, setForm] = useState({ url: '', type: 'Portfolio' });

  const handleSubmit = (e) => {
    e.preventDefault();

    const tempObj = { ...form };

    const newUserCopy = { ...userCopy };
    const tempArr = newUserCopy.links;
    tempArr.push(tempObj);
    newUserCopy.links = tempArr;

    editUser(newUserCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  return (
    <>
      <h2 className="heading">
        <small>Links</small>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-6">
              <label htmlFor="inputURL" className="form-label">
                URL
              </label>
              <input
                type="text"
                className="form-control"
                id="inputURL"
                placeholder="http://"
                value={form.url}
                onChange={(e) =>
                  setForm((prev) => {
                    return { ...prev, url: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="inputType" className="form-label">
                Link type
              </label>
              <select
                id="inputType"
                className="form-select"
                value={form.type}
                onChange={(e) =>
                  setForm((prev) => {
                    return { ...prev, type: e.target.value };
                  })
                }
              >
                <option value="Portfolio">Portfolio</option>
                <option value="Personal page">Personal page</option>
                <option value="Company page">Company page</option>
                <option value="Project">Project</option>
                <option value="Social media">Social media</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
